export enum HourlyRequestModalType {
   Details,
   Cancel
}